export default __webpack_public_path__ + "static/media/closet5-before2-480w.bdf54c2a.avif";